/* istanbul ignore file */

import { FORM_FIELDS } from './form-fields';

export const FORM_PATHS = {
  STATUS_FILTER: () => FORM_FIELDS.STATUS_FILTER,
  WEBSITES_FILTER: () => FORM_FIELDS.WEBSITES_FILTER,
  CONTENT_TYPE_FILTER: () => FORM_FIELDS.CONTENT_TYPE_FILTER,
  MODIFIED_FILTER: () => FORM_FIELDS.MODIFIED_FILTER,
  TOPIC_FILTER: () => FORM_FIELDS.TOPIC_FILTER,
  AUTHOR_FILTER: () => FORM_FIELDS.AUTHOR_FILTER,
  CONTENT_SEARCH_FILTER: () => FORM_FIELDS.CONTENT_SEARCH_FILTER,
};
